import Swiper from '../../../../../../../node_modules/swiper/swiper-bundle.esm.browser.js';

export function Slider() {
  const swiper = new Swiper('.machine-page-slider', {
    navigation: {
      nextEl: '.machine-page-slider__button--next',
      prevEl: '.machine-page-slider__button--prev',
    },
    slidesPerView: 'auto',
    spaceBetween: 20,
    slidesOffsetAfter: 16,
    slidesOffsetBefore: 16,
  });
}

export function LinePageSlider() {
  const lineSwiper = new Swiper('.line-slider-container', {
    modules: [lineSliderPlugin],
    navigation: {
      nextEl: '.swiper__button--next',
      prevEl: '.swiper__button--prev',
    },
    on: {
        init: function () {
          const otherPic = document.querySelector('.machine-groups-covers');
          const tab = document.querySelector('.machine-groups-tabs button');
          if ( otherPic && tab ) {
            otherPic.classList.add('active');
            tab.classList.add('active');
          }
        },
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1400: {
        slidesPerView: 'auto',
        spaceBetween: 60,
        slidesOffsetAfter: 128,
      },
    },
  });

  function lineSliderPlugin({ swiper, on }) {
    on('slideChange', () => {
      const activeI = swiper.activeIndex;
      const otherPic = document.querySelectorAll('.machine-groups-covers');
      const tabs = document.querySelectorAll('.machine-groups-tabs button');
      let selectOption = document.getElementById('macGr') as HTMLSelectElement;
      for (let i = 0; i < otherPic.length; i++) {
          const el = otherPic[i];
          el.classList.remove('active');
          if (i === activeI) {
            el.classList.add('active');
          }
      }
      for (let x = 0; x < tabs.length; x++) {
          const tab = tabs[x];
          tab.classList.remove('active');
          if (x === activeI) {
            tab.classList.add('active');
          }
      }
      if (selectOption) { selectOption.selectedIndex = activeI; }
    });
  }

  function machineGroupChanged(mg) {
      const macgroupId = mg.value;
      lineSwiper.slideTo(macgroupId);
  }

  globalThis.lineSwiper = lineSwiper;
  globalThis.machineGroupChanged = machineGroupChanged;
}
